import { useFormContext, Controller } from "react-hook-form";
import { useRecoilValue, useSetRecoilState } from "recoil";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { branchManagerChanged } from "../atoms/atoms";
import useGetActiveEmployees from "../../Employees/Confie/hooks/useGetActiveEmployees";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import useGetHrBusPartnerEmployees from "modules/CarrierAgreementMgmt/Employees/Confie/hooks/useGetHrBusPartnerEmployees";

const OfficeHierarchy = ({ disableFields }) => {
  const formMethods = useFormContext();

  const user = useRecoilValue(accountAtom);
  const { data: employees, isLoading: empLoading } = useGetActiveEmployees();
  const setManagerChanged = useSetRecoilState(branchManagerChanged);
  const { data: hrBusinessPartnerEmployees, isLoading: busPartnerEmpLoading } =
    useGetHrBusPartnerEmployees();

  const officeHierarchyId = formMethods.watch("officeHierarchyId");

  const employeeList = employees
    ?.filter((y) => y.status !== "Terminated" && y.status !== "Inactive")
    .map((x) => {
      return {
        id: x.employeeId,
        value: x.employeeId,
        label: x.fullname + "-" + x.employeenumber,
        email: x.email,
        officeType: x.officeType,
        officeCode: x.officecode,
      };
    });

  const hrBusPartnerEmployeeList = hrBusinessPartnerEmployees?.map((x) => {
    return {
      value: x.employeeId,
      label: x.employeeNumber
        ? `${x.fullname} - ${x.employeeNumber}`
        : x.fullname,
    };
  });

  return (
    <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 pb-4">
      <div className="text-quinary font-bold font-sans py-2 px-4">
        Office Hierarchy and Leadership
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 px-4 gap-12">
        <div className="space-y-1">
          <TextInputLabelHookForm
            name="officeHierarchyEffectiveDate"
            label="Office Hierarchy Effective Date"
            type="date"
            disabled={disableFields}
            required={!!officeHierarchyId}
            className={
              formMethods.formState.errors.officeHierarchyEffectiveDate &&
              "border-2 border-red-500 "
            }
            register={formMethods.register("officeHierarchyEffectiveDate", {
              required: {
                value: !!officeHierarchyId,
                message: "Required Field",
              },
            })}
          />
          <Controller
            control={formMethods.control}
            name="branchManagerId"
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  formMethods.setValue("branchManagerName", e ? e.label : null);
                  setManagerChanged(true);
                }}
                value={field.value}
                options={employeeList?.filter(
                  (x) =>
                    x.officeType === formMethods.watch("officeType") &&
                    x.officeCode !== "" &&
                    x.officeCode !== null
                )}
                isLoading={empLoading}
                label="Branch Manager"
                isDisabled={
                  disableFields ||
                  (formMethods.watch("officeType") ? false : true)
                }
                placeHolder={
                  formMethods.watch("officeTypeId")
                    ? formMethods.watch("branchManagerId")
                      ? formMethods.watch("branchManagerName")
                      : undefined
                    : "Select Office Type to enable"
                }
              />
            )}
          />
          {officeHierarchyId && (
            <div className="py-4 space-y-4">
              <div>
                <TextInputHookFormDisabled
                  name="districtName"
                  label="District Name"
                  type="text"
                  register={formMethods.register("districtName", {})}
                />
                <TextInputHookFormDisabled
                  name="districtCode"
                  label="District Code"
                  type="text"
                  register={formMethods.register("districtCode", {})}
                />
                <TextInputHookFormDisabled
                  name="districtManager"
                  label="Office District Manager"
                  type="text"
                  register={formMethods.register("districtManager", {})}
                />
              </div>
              <div>
                <TextInputHookFormDisabled
                  name="areaName"
                  label="Area Name"
                  type="text"
                  register={formMethods.register("areaName", {})}
                />
                <TextInputHookFormDisabled
                  name="areaCode"
                  label="Area Code"
                  type="text"
                  register={formMethods.register("areaCode", {})}
                />
                <TextInputHookFormDisabled
                  name="salesVp"
                  label="Sales VP"
                  type="text"
                  register={formMethods.register("salesVp", {})}
                />
              </div>
            </div>
          )}
        </div>
        <div className="space-y-1">
          {((!user.isFranchise && user.isNonFranchise) ||
            (formMethods.watch("officeType") &&
              formMethods.watch("officeType")?.toLowerCase() !==
                "franchise")) && (
            <>
              <Controller
                control={formMethods.control}
                name="hrBusinessPartnerId"
                render={({ field }) => (
                  <SelectHookFormSingle
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                    }}
                    value={field.value}
                    options={hrBusPartnerEmployeeList}
                    isLoading={busPartnerEmpLoading}
                    label="HR Business Partner"
                  />
                )}
              />
              <div className="py-4 space-y-4"> </div>
            </>
          )}

          {((user.isFranchise && !user.isNonFranchise) ||
            formMethods.watch("officeType")?.toLowerCase() === "franchise") && (
            <>
              <Controller
                control={formMethods.control}
                name="businessConsultantId"
                // rules={{
                //   required:
                //     (user.isFranchise && !user.isNonFranchise) ||
                //     formMethods.watch("officeType") === "Franchise",
                // }}
                render={({ field }) => (
                  <SelectHookFormSingle
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                    }}
                    value={field.value}
                    options={employeeList}
                    isLoading={empLoading}
                    label="Business Consultant"
                    isDisabled={disableFields}
                  />
                )}
              />

              <TextInputLabelHookForm
                name="franchiseOwner"
                label="Franchise Owner"
                register={formMethods.register("franchiseOwner", {})}
                disabled={disableFields}
              />
            </>
          )}

          {officeHierarchyId && (
            <div className="py-4 space-y-4">
              <div>
                <TextInputHookFormDisabled
                  name="regionName"
                  label="Region Name"
                  type="text"
                  register={formMethods.register("regionName", {})}
                />
                <TextInputHookFormDisabled
                  name="regionCode"
                  label="Region Code"
                  type="text"
                  register={formMethods.register("regionCode", {})}
                />
              </div>
              <div>
                <TextInputHookFormDisabled
                  name="territoryName"
                  label="Territory Name"
                  type="text"
                  register={formMethods.register("territoryName", {})}
                />
                <TextInputHookFormDisabled
                  name="territoryCode"
                  label="Territory Code"
                  type="text"
                  register={formMethods.register("territoryCode", {})}
                />
                <TextInputHookFormDisabled
                  name="salesPresident"
                  label="Sales President"
                  type="text"
                  register={formMethods.register("salesPresident", {})}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfficeHierarchy;
